import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProductsService } from '../../../shared/services/products.service';

@Component({
  selector: 'app-product-overview',
  templateUrl: './product-overview.component.html',
  styleUrls: ['./product-overview.component.scss'],
  standalone: false,
})
export class ProductOverviewComponent {
  constructor(
    private router: Router,
    private productsService: ProductsService,
  ) {}

  /**
   * Check if a route is active (included in the current router URL)
   */
  isActive(route: string): boolean {
    return this.router?.url?.includes(route) ?? false;
  }

  /**
   * Handle details tab click event
   */
  onDetailsTabClick(): void {
    this.productsService?.clearSelectedCheckboxes();
    this.productsService?.setFilteredSelectedRows([]);
  }
}
